enum ActivationPoint {
  All,
  One,
  Many,
}

export default ActivationPoint
